import React, { useState, useEffect, Fragment } from "react";
import services from "../services";
import { taskTemplateBulkSchemaObject } from "../taskTemplateBulkSchema";
import { validateProperty, validate } from "../../Common";
import MessageModal from "../../../UI/Modal/MessageModal";
import { PageHeader } from "../../../Common";
import Joi from "@hapi/joi";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import authService from "../../Common/services";
import tokenService from "../../../Common/tokenDecoder";
import MaterialTable from "material-table";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import collectionCatagoryService from "../../CollectionCategory/services";
import { MultiSelect } from "../../../Common/multiSelect";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

const screenCode = "TASKTEMPLATEBULK";

export function EditTaskTemplateBulk(props) {


  const [selectedOptions, setSelectedOptions] = useState([]);
  const getOptionLabel = option => `${option.label}`;
  const getOptionDisabled = option => option.value === "foo";
  const handleToggleOption = selectedOptions =>
    setSelectedOptions(selectedOptions);
  const handleClearOptions = () => setSelectedOptions([]);
  const handleSelectAll = isSelected => {
    if (isSelected) {
      setSelectedOptions(alldeductionType);
    } else {
      handleClearOptions();
    }
  };
  const [pageProperties, setPageProperties] = useState({
    title: "Edit Task Template Bulk",
    buttonText: "Search",
  });
  const [groups, setGroups] = useState();
  const [factoriesData, setFactoriesData] = useState();
  const [isDropdownDisable, setIsDropdownDisable] = useState(false);
  const [IsHideTable, setIsHideTable] = useState(true);
  const [searchButton, setSearchButton] = useState(true);
  const [labourTask, setLabourTask] = useState()
  const [taskCategory, setTaskCategory] = useState();
  const [editTableData, setEditTableData] = useState();
  const [estates, setEstates] = useState()
  const [alldeductionType, setAllDeductionType] = useState([]);
  const [deductionType, setDeductionType] = useState();
  const [applyMethods, setApplyMethods] = useState();
  const [deduction, setDeduction] = useState({
    deductionTemplateID: "0",
    groupID: 0,
    groupName: "",
    operationEntityID: 0,
    factoryName: "",
    collectionPointID: 0,
    collectionCategoryMenuID: 0,
    collectionPointName: "",
    deductionTypeID: 0,
    deductionTypeName: "",
    applyMethodID: "0",
    collectionCategoryID: 0,
    defaultValue: 0,
    minimumValue: 0,
    isFixed: false,
    isActive: true,
    isDefaultValueEnabled: false,
    createdBy: "",
    createdDate: "",
    entityTypeID: 0,
    estateTaskID: "0",
    date: "",
    numberOfWorkers: "",
    sundryTask: "0",
    isCirculation: false,
    fixedDeductions: [],
  });
  const [errors, setErrors] = useState({});
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Save/ Edit success",
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });
  const schema = Joi.object(taskTemplateBulkSchemaObject).options({
    allowUnknown: true,
  });
  const [state, setState] = useState({
    columns: [
      { title: "Deduction Type", field: "name" },
      { title: "Value", field: "value", type: "numeric" },
    ],
    data: [],
  });
  const [stateData, setStateData] = useState(0);

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    if (deduction.groupID != 0) {
      trackPromise(getEstates());
    }
  }, [deduction.groupID]);

  useEffect(() => {
    trackPromise(getTaskNames(),
      getDivisionsForDropDown());

  }, [deduction.operationEntityID]);

  useEffect(() => {
    trackPromise(getLabourTask());

  }, [deduction.estateTaskID]);

  useEffect(() => {
    EnableButton();
  }, [deduction.sundryTask]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "EDITTASKTEMPLATEBULK"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );
    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();
    setDeduction({
      ...deduction,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });

    trackPromise(
      setGroupDropDownData(),
      setApplyMethodsData(),
      setDeductionTypeDropDownData()
    );
  }

  async function setGroupDropDownData() {
    const result = await services.getGroups();
    setGroups(result);
  }

  async function getOperationEntitiesForDropdown() {
    const opEntities = await services.getAllOperationEntitiesForDropDown(
      deduction.groupID
    );
    setFactoriesData(opEntities);
  }

  async function getLabourTask() {
    const result = await services.getLabourTaskByOperationEntityIDTaskCategoryID(deduction.operationEntityID, deduction.estateTaskID)
    setLabourTask(result)
  }

  async function getTaskNames() {
    const result = await services.getAllTaskNames(deduction.groupID, deduction.operationEntityID);
    setTaskCategory(result);
  }

  async function setDeductionTypeDropDownData() {
    const result = await services.getDeductionTypes();
    setDeductionType(result);
  }

  async function getEstates() {
    const result = await services.GetAllOperationEntityByGroupID(deduction.groupID)
    setEstates(result)
  }

  async function getDivisionsForDropDown() {
    let data = await services.getDivisionByEstateID(deduction.operationEntityID);
    var options = []
    for (let item of Object.entries(data)) {
      options.push({ label: item[1]["collectionPointName"], value: item[1]["collectionPointID"] });
    }
    setAllDeductionType(options);
  }

  async function setApplyMethodsData() {
    const result = await services.getApplyMethods();
    setApplyMethods(result);
  }
  async function EnableButton() {
    if(deduction.sundryTask == "0"){
      setSearchButton(true);
    }
    else{
      setSearchButton(false);
    }
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, taskTemplateBulkSchemaObject);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];
    setErrors(error);
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setDeduction({
      ...deduction,
      groupID: target.value,
      operationEntityID: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setDeduction({
      ...deduction,
      operationEntityID: target.value,
      collectionCategoryID: "0",
    });
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    setDeduction({
      ...deduction,
      [e.target.name]: value,
    });
  }

  function SwitchHandleChange(e,data) {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    let dataReport = [...editTableData];
    dataReport.forEach(x => {
      if (x.employeeTaskTemplateID == data.employeeTaskTemplateID) {
        x.isActive = value
      }
      setEditTableData(dataReport)
    });
  }

  async function handleUpdate() {
    editTableData.forEach(x => {
      x.userID = parseInt(tokenService.getUserIDFromToken());
    })
    const response = await services.UpdateTaskTemplateBulk(editTableData)
    setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
    afterSuccessfulyChanged(response.statusCode)
  }


  function afterSuccessfulyChanged(response) {
    if (response === "Success") {
      setTimeout(() => {
        modalDismissHandler();
        clearFilter();
      }, 1500);
    }
  }
  function clearFilter() {
    setDeduction({
      ...deduction,
      estateTaskID: "0",
      sundryTask: "0"
    });
    setIsHideTable(true);
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  async function GetEditData() {
    const response = await services.GetEditTaskTemplateBulk(deduction.groupID, deduction.operationEntityID, deduction.estateTaskID, deduction.sundryTask);
    response.forEach(x => {
      x.taskExpiration = x.taskExpiration.split('T')[0];
    })
    setEditTableData(response);
    setIsHideTable(false);
  }

  function renderDropDown(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div>
        <div className="card">
          <div className="card-body">
            <div className="row">
              <PageHeader
                title={pageProperties.title}
              />
            </div>

            <div className="form-group row">
              <div className="col-md pb-1">
                <InputLabel shrink id="groupID">
                  Group *
                </InputLabel>
                <Select
                  fullWidth
                  id="groupID"
                  disabled={
                    isDropdownDisable || !permissionList.isGroupFilterEnabled
                  }
                  name="groupID"
                  value={deduction.groupID}
                  onChange={(e) => handleGroupChange(e.target)}
                >
                  <MenuItem value="0">--Select Group Name--</MenuItem>
                  {renderDropDown(groups)}
                </Select>
                {errors["groupID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>)}
              </div>

              <div className="col-md pb-1">
                <InputLabel shrink id="operationEntityID">
                Operation Entity *
                </InputLabel>
                <Select
                  fullWidth
                  id="operationEntityID"
                  disabled={
                    isDropdownDisable ||
                    !permissionList.isOperationEntityFilterEnabled
                  }
                  name="operationEntityID"
                  value={deduction.operationEntityID}
                  onChange={(e) => handleOperationEntityChange(e.target)}
                >
                  <MenuItem value="0">--Select Operation Entity--</MenuItem>
                  {renderDropDown(estates)}
                </Select>
                {errors["operationEntityID"] && (
                  <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>)}
              </div>
              <div className="col-md pb-1">
                <InputLabel shrink id="estateTaskID">Task Category *</InputLabel>
                <Select
                  fullWidth
                  id="estateTaskID"
                  name="estateTaskID"
                  value={deduction.estateTaskID}
                  onChange={(e) => handleChange(e)}>
                  <MenuItem value="0">--Select Task Category--</MenuItem>
                  {renderDropDown(taskCategory)}
                </Select>
                {errors["taskCategory"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["taskCategory"]}</FormHelperText>)}
              </div>
              <div className="col-md pb-1">
                <InputLabel shrink id="sundryTask">Sundry Task *</InputLabel>
                <Select
                  fullWidth
                  id="sundryTask"
                  name="sundryTask"
                  value={deduction.sundryTask}
                  onChange={(e) => handleChange(e)}>
                  <MenuItem value="0">--Select Sundry Task--</MenuItem>
                  {renderDropDown(labourTask)}
                </Select>
                {errors["sundryTask"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["sundryTask"]}</FormHelperText>)}
              </div>
            </div>
            <div className="card-footer">
              <input
                disabled={searchButton}
                onClick={GetEditData}
                type="button"
                className="btn btn-primary"
                value={pageProperties.buttonText}
              />
            </div>
          </div>
        </div>
        <Grid item md={12} xs={12} hidden={IsHideTable}>
          <MaterialTable
            columns={[
              {
                title: 'Divison', field: 'collectionPointName',
                headerStyle: { fontWeight: "bold" },
                editable: 'never'
              },
              {
                title: 'Task Expiration', field: 'taskExpiration',
                headerStyle: { fontWeight: "bold" },
                type: 'date'
              },
              {
                title: 'Number Of Workers', field: 'numberOfWorkers',
                headerStyle: { fontWeight: "bold" },
                type: 'number'
              },
              {
                title: 'Circulation Months', field: 'circulationMonths',
                headerStyle: { fontWeight: "bold" },
                type: 'number'
              },
              {
                title: 'IsActive', type: "boolean",
                headerStyle: { fontWeight: "bold" },
                editable: 'never',
                render: (data) => (
                  <Switch
                    checked={data.isActive}
                    onChange={(e) => SwitchHandleChange(e,data)}
                  />
                ),
              },
            ]}
            data={editTableData}
            options={{
              exportAllData: true,
              showTitle: false,
              headerStyle: { textAlign: "left", height: '1%' },
              cellStyle: { textAlign: "left" },
              columnResizable: false,
              pageSize: 5
            }}
            cellEditable={{
              onCellEditApproved: (newValue, oldValue, rowData, columnDef) => {
                return new Promise((resolve, reject) => {
                  const clonedData = [...editTableData]
                  if (columnDef.field == "taskExpiration") {
                    if (newValue == null) {
                      clonedData[rowData.tableData.id][columnDef.field] = convert(oldValue)
                    }
                    else {
                      clonedData[rowData.tableData.id][columnDef.field] = convert(newValue)
                    }
                  } 
                  else{
                    if (newValue == '' || newValue < 0) {
                      clonedData[rowData.tableData.id][columnDef.field] = parseInt(oldValue)
                    }
                    else {
                      clonedData[rowData.tableData.id][columnDef.field] = parseInt(newValue)
                    }
                  }
                  setEditTableData(clonedData)
                  setTimeout(resolve, 600);
                });
              }
            }}
          />
        </Grid>
        <div className="card-footer" hidden={IsHideTable}>
              <input
                onClick={handleUpdate}
                type="button"
                className="btn btn-primary"
                value='update'
              />
            </div>
        <MessageModal
          hidden={messageModel.hidden}
          messageType={messageModel.type}
          messageDescription={messageModel.disciption}
          clicked={modalDismissHandler}
        />
      </div>
    </Fragment>
  );
}
